import {
  SERVICE_PLAN_PHOTO,
  SERVICE_PLAN_FREE,
  SERVICE_PLAN_STANDARD,
  SERVICE_PLAN_NOTOPEN,
} from '@/constant/codmonPricing';

interface PlanNameStrategy {
  getPlanName(): string;
}

interface planNames {
  [key: number]: string;
}

export class Before202305Strategy implements PlanNameStrategy {
  constructor(private planId: number) {}

  getPlanName(): string {
    const planNameBefore202305: planNames = {
      [SERVICE_PLAN_PHOTO]: 'フリー',
      [SERVICE_PLAN_FREE]: 'デモ',
      [SERVICE_PLAN_STANDARD]: 'スタンダード',
      [SERVICE_PLAN_NOTOPEN]: '未オープン',
    };
    return `${planNameBefore202305[this.planId]}プラン`;
  }
}

export class After202305Strategy implements PlanNameStrategy {
  constructor(private planId: number, private isMainFacility: boolean, private usePackplan: boolean) {}

  getPlanName(): string {
    const planNameAfter202305: planNames = {
      [SERVICE_PLAN_PHOTO]: '無料施設会員',
      [SERVICE_PLAN_FREE]: this.isMainFacility ? '本部アカウント（無料）' : 'コドモン無料期間',
      [SERVICE_PLAN_STANDARD]: this.usePackplan ? 'コドモンパックプラン' : 'コドモンベーシック',
    };
    return planNameAfter202305[this.planId] ? planNameAfter202305[this.planId] : '-';
  }
}

export class PlanNameContext {
  constructor(private strategy: PlanNameStrategy) {}

  getPlanName(): string {
    return this.strategy.getPlanName();
  }
}
